/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal, Tabs, Tab, Form } from 'react-bootstrap';
import { isNil } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';
import { Bert } from 'meteor/themeteorchef:bert';
import { withTracker } from 'meteor/react-meteor-data';

import {
  isPasswordUser,
  isOauthUser,
  getEmailAddress,
  getDefaultBaseMap,
  getFeatureSelectedWeight,
  getFeatureSelectedColor
} from '../../../api/Users/user-operations';
import LayersCollection from '../../../api/Layers/Layers';

import { isIAS, isMaps } from '../../../modules/checkDeployEnv';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import AccountPageFooter from '../../components/AccountPageFooter';
import Footer from '../../components/Footer';
import OAuthUserProfile from '../../components/OAuthUserProfile';
import PasswordUserProfile from '../../components/PasswordUserProfile';
import UserConfiguration from '../../components/UserConfiguration';
import UserSettings from '../../components/UserSettings';

import Validation from '../../containers/Validation';

import PageHeader from '../../atoms/PageHeader';
import AIConfiguration from '../../components/AISettingEditor';
import APIConfiguration from '../../components/APISettingEditor';
import UserControlEditor from '../../components/UserControlEditor';
import ServerInfra from '../../components/ServerInfrastrucrure';

class Profile extends Component {
  state = {
    deleteAccountAlert: false,
    activeTab: 'profile'
  };

  openDeleteAccountAlert = () => {
    this.setState({ deleteAccountAlert: true });
  };

  closeDeleteAccountAlert = () => {
    this.setState({ deleteAccountAlert: false });
  };

  changeActiveTab = newActiveTab => {
    this.setState({ activeTab: newActiveTab });
  };

  deleteAccount = async () => {
    try {
      const { deletedFiles, deletedFolders } = await methodPromise('users.hardDelete');
      Bert.alert(`User deleted! ${deletedFiles} files and ${deletedFolders} folders`, 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleSubmit = async form => {
    const { user, userControlSetting } = this.props;
    const profile = {
      emailAddress: form.emailAddress.value,
      profile: {
        name: {
          first: form.firstName.value,
          last: form.lastName.value
        },
        defaultBaseMap: getDefaultBaseMap(user),
        featureSelectedColor: getFeatureSelectedColor(user),
        featureSelectedWeight: getFeatureSelectedWeight(user),
        defaultMapCenter: userControlSetting.defaultMapCenter
      }
    };
    try {
      await methodPromise('users.editProfile', profile);
      Bert.alert('Profile updated!', 'success');
      if (form.newPassword.value) {
        Accounts.changePassword(form.currentPassword.value, form.newPassword.value, error => {
          if (error) {
            handleErrorInClient(error);
          } else {
            form.currentPassword.value = ''; // eslint-disable-line
            form.newPassword.value = ''; // eslint-disable-line
            form.repeatNewPassword.value = ''; // eslint-disable-line
          }
        });
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  render() {
    const {
      loading,
      user,
      deployEnv,
      history,
      layerList,
      isAdmin,
      userControlSetting
    } = this.props;
    const { deleteAccountAlert, activeTab } = this.state;
    const validationProps = {
      rules: {
        firstName: {
          required: true
        },
        lastName: {
          required: true
        },
        emailAddress: {
          required: true,
          email: true
        },
        currentPassword: {
          required: form => {
            // Only required if newPassword field has a value.
            return form.form.newPassword.value.length > 0;
          }
        },
        newPassword: {
          required: form => {
            // Only required if currentPassword field has a value.
            return form.form.currentPassword.value.length > 0;
          }
        },
        repeatNewPassword: {
          minlength: 6,
          equalTo: '[name="newPassword"]',
          required: form => {
            // Only required if currentPassword field has a value.
            return form.form.currentPassword.value.length > 0;
          }
        }
      },
      messages: {
        firstName: {
          required: "What's your first name?"
        },
        lastName: {
          required: "What's your last name?"
        },
        emailAddress: {
          required: 'Need an email address here.',
          email: 'Is this email address correct?'
        },
        currentPassword: {
          required: 'Need your current password if changing.'
        },
        newPassword: {
          required: 'Need your new password if changing.'
        },
        repeatNewPassword: {
          required: 'Repeat your new password, please.',
          equalTo: "Hmm, your passwords don't match. Try again?"
        }
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };
    if (!loading && isNil(user)) {
      history.push('/logout');
      return '';
    }
    return (
      <>
        <PageHeader>
          <h4>Edit Profile</h4>
        </PageHeader>
        <Tabs onSelect={this.changeActiveTab} id="profile-tabs">
          <Tab eventKey="profile" title="Profile">
            <Row>
              <Col xs={12} sm={8} md={6}>
                <Validation {...validationProps}>
                  <Form onSubmit={event => event.preventDefault()}>
                    {!loading && isPasswordUser(user) && <PasswordUserProfile user={user} />}
                    {!loading && isOauthUser(user) && <OAuthUserProfile user={user} />}
                  </Form>
                </Validation>
                <AccountPageFooter deployEnv={deployEnv}>
                  <Button variant="danger" onClick={this.openDeleteAccountAlert}>
                    Delete My Account
                  </Button>
                  {isMaps(deployEnv) && <Footer positionRelative={isMaps(deployEnv)} />}
                </AccountPageFooter>
              </Col>
            </Row>
          </Tab>
          {(isIAS(deployEnv) || isMaps(deployEnv)) && isAdmin && (
            <Tab eventKey="telemetry" title={isMaps(deployEnv) ? 'Server Connection' : 'Telemetry'}>
              {activeTab === 'telemetry' && <UserConfiguration deployEnv={deployEnv} />}
            </Tab>
          )}
          {isMaps(deployEnv) && isAdmin && (
            <Tab eventKey="ServerMetedata" title="Server Infrastructure">
              {activeTab === 'ServerMetedata' && (
                <>
                  <h4>Infraestructura de servidores</h4>
                  <ServerInfra />
                </>
              )}
            </Tab>
          )}

          {isAdmin && (
            <Tab eventKey="AIconfig" title="AI Setting">
              {activeTab === 'AIconfig' && (
                <>
                  <h1> AI Setting </h1>
                  <AIConfiguration />
                </>
              )}
            </Tab>
          )}
          {isAdmin && (
            <Tab eventKey="APIConfig" title="API Setting">
              {activeTab === 'APIConfig' && (
                <>
                  <h1> API Setting </h1>
                  <APIConfiguration />
                </>
              )}
            </Tab>
          )}
          {isAdmin && (
            <Tab eventKey="UserControl" title="User Control">
              {activeTab === 'UserControl' && (
                <>
                  <h1> User Control </h1>
                  <UserControlEditor initialSetting={userControlSetting} />
                </>
              )}
            </Tab>
          )}
          {isAdmin && (
            <Tab eventKey="settings" title="Settings">
              {/* Manually check the activeTab value to ensure we refetch settings on re-render of UserSettings */}
              {activeTab === 'settings' && (
                <UserSettings
                  deployEnv={deployEnv}
                  layerList={layerList}
                  profile={{ profile: user.profile, emailAddress: getEmailAddress(user) }}
                  userControlSetting={userControlSetting}
                />
              )}
            </Tab>
          )}
        </Tabs>
        <Modal show={deleteAccountAlert} onHide={this.closeDeleteAccountAlert}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Account</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            This action will delete your account and all it&apos;s data. This will be irreversible
            and effective inmediatly. We will not be able to recover your lost data in any way. Are
            your sure?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeDeleteAccountAlert}>
              Close
            </Button>
            <Button variant="danger" onClick={this.deleteAccount}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

Profile.propTypes = {
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired,
  layerList: PropTypes.array.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  userControlSetting: PropTypes.object.isRequired
};

export default withTracker(() => {
  const subscription = Meteor.subscribe('users.editProfile');
  const layersSub = Meteor.subscribe('layers');
  const gmsConnectionsSub = Meteor.isClient && Meteor.subscribe('gmsConnections');

  return {
    loading: !subscription.ready() && !layersSub.ready() && !gmsConnectionsSub.ready(),
    user: Meteor.user(),
    layerList: LayersCollection.find({ deleted: { $eq: 'no' } }).fetch()
  };
})(Profile);
